<template src="./Index.html">
</template>

<script>

export default {
        created() {
        this.$store.dispatch("lookups/getBanks")
        this.$store.dispatch("lookups/getLookups");

        
        },
        model: {
            prop: "employee",
        },
        props: ["employee"],
        computed: {
            banks() {
                return this.$store.state.lookups.banks;

            },
            jobGrades() {
                return this.$store.state.lookups.jobGrades;
            },
            correlators() {
                return this.$store.getters["lookups/getLookupByType"](
                    this.$lookupTypes.Correlators
                );
            },
  },
  data() {
      return {
  
    }
  },
        methods: {
            calculateSalary() {

                let index = this.jobGrades.findIndex(x => x.value == this.employee.employmentInformation.jobGradeId);
                let index2 = this.correlators.findIndex(x => x.value == this.employee.employmentInformation.currentCorrelatorId);
                let grade = this.correlators[index2].label
                this.employee.financialInformation.salary= this.jobGrades[index].correlatorStart + grade * this.jobGrades[index].annualBonus
                return this.employee.financialInformation.salary

            },
            upload() {

                const reader = new FileReader();
                if (event.target.files.length) {
                    reader.readAsDataURL(event.target.files[0])
                    reader.onload = (event) => {
                        this.employee.financialInformation.chequePhoto = event.target.result;


                    };
                }
            },
      nextStep() {
          this.$emit("nextStep");

      },
      prevStep() {
        this.$emit("prevStep");
      },
      allowedDates(val) {
          const today = new Date();
          today.setFullYear(today.getFullYear() - 15);
          const date = new Date(val);
          return date < today;
      },
  
  },
};
</script>
